import {circle, distance} from '@turf/turf';

export default class CircleDrawControl {
  constructor(options = {}) {
    this._map = null;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl';
    this._center = null;
    this._drawing = false;
    this._sourceId = options.sourceId || 'circle';
    this._layerId = options.layerId || 'circle';
    this._lineSourceId = options.lineSourceId || 'circle-radius-line';
    this._lineLayerId = options.lineLayerId || 'circle-radius-line';
    this._onComplete = options.onComplete || (() => {});
  }

  onAdd(map) {
    this._map = map;

    this._boundClick = this._handleClick.bind(this);
    this._boundMouseMove = this._handleMouseMove.bind(this);

    map.on('click',this._boundClick);
    map.on('mousemove', this._boundMouseMove);

    return this._container;
  }

  onRemove() {
    this._map.off('click', this._boundClick);
    this._map.off('mousemove', this._boundMouseMove);

  }
  onStopCircleDrawing(){
    if(!this._map) return;
    ['circle', 'center-marker', 'radius-label','circle-radius-line'].forEach(id => {
      if (this._map.getLayer(id)) this._map.removeLayer(id);
      if (this._map.getSource(id)) this._map.removeSource(id);
    });
  }

  _handleClick(e) {
    if (!this._drawing) {
      this._center = [e.lngLat.lng, e.lngLat.lat];
      this._drawing = true;

      // Circle
      if (!this._map.getSource(this._sourceId)) {
        this._map.addSource(this._sourceId, {
          type: 'geojson',
          data: circle(this._center, 0, { units: 'meters' }),
        });
        this._map.addLayer({
          id: this._layerId,
          type: 'fill',
          source: this._sourceId,
          paint: {
            'fill-color': '#4caf50',
            'fill-opacity': 0.5,
          },
        });
      }

      // LineString for radius line
      if (!this._map.getSource(this._lineSourceId)) {
        this._map.addSource(this._lineSourceId, {
          type: 'geojson',
          data: {
            type: 'Feature',
            geometry: {
              type: 'LineString',
              coordinates: [this._center, this._center],
            },
          },
        });
        this._map.addLayer({
          id: this._lineLayerId,
          type: 'line',
          source: this._lineSourceId,
          layout: {
            'line-cap': 'round',
            'line-join': 'round',
          },
          paint: {
            'line-color': '#4caf50',
            'line-width': 2,
            'line-dasharray': [2, 4], 
          },
        });
      }
      // Center Point
      this._map.addSource('center-marker', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: this._center },
        },
      });
      this._map.addLayer({
        id: 'center-marker',
        type: 'circle',
        source: 'center-marker',
        paint: {
          'circle-radius': 5,
          'circle-color': '#000',
          'circle-stroke-width': 1,
          'circle-stroke-color': '#fff',
        },
      });

      // Radius label 
      this._map.addSource('radius-label', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: this._center },
          properties: { label: '' },
        },
      });
      this._map.addLayer({
        id: 'radius-label',
        type: 'symbol',
        source: 'radius-label',
        layout: {
          'text-field': ['get', 'label'],
          'text-size': 14,
          'text-offset': [0, -1.5],
          'text-anchor': 'top',
        },
        paint: {
          'text-color': '#333',
          'text-halo-color': '#fff',
          'text-halo-width': 1,
        },
      });

    } else {
      this._drawing = false;

      this._onComplete({
        center: this._center,
        radius: Math.round(this._lastRadius) || 0,
      });
    }
  }

  _handleMouseMove(e) {
    if (!this._drawing || !this._center) return;

    const pointer = [e.lngLat.lng, e.lngLat.lat];
    const radius = distance(this._center, pointer, { units: 'meters' });
    this._lastRadius = radius;

    const circleS = circle(this._center, radius, {
      steps: 64,
      units: 'meters',
    });

    const source = this._map.getSource(this._sourceId);
    if (source) source.setData(circleS);

    const lineSource = this._map.getSource(this._lineSourceId);
    if (lineSource) {
      lineSource.setData({
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: [this._center, pointer],
        },
      });
    }
    const labelSrc = this._map.getSource('radius-label');
    if (labelSrc) {
      labelSrc.setData({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: this._center },
        properties: { label: `Radius: ${Math.round(radius)} m` },
      });
    }
  }

}
